var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dl",
    [
      _vm.firmAttributes.name && _vm.displayName
        ? _c("dt", [_vm._v("\n        Name\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.name && _vm.displayName
        ? _c("dd", [
            _vm._v("\n        " + _vm._s(_vm.firmAttributes.name) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.nameAffix
        ? _c("dt", [_vm._v("\n        Name Zusatz\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.nameAffix
        ? _c("dd", [
            _vm._v(
              "\n        " + _vm._s(_vm.firmAttributes.nameAffix) + "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.street
        ? _c("dt", [_vm._v("\n        Straße\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.street
        ? _c("dd", [
            _vm._v("\n        " + _vm._s(_vm.firmAttributes.street) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.city && _vm.firmAttributes.postalCode
        ? _c("dt", [_vm._v("\n        Ort\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.city && _vm.firmAttributes.postalCode
        ? _c("dd", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.firmAttributes.postalCode) +
                "\n        " +
                _vm._s(_vm.firmAttributes.city) +
                "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.phone
        ? _c("dt", [_vm._v("\n        Telefon\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.phone
        ? _c("dd", [
            _c("a", { attrs: { href: "tel://" + _vm.firmAttributes.phone } }, [
              _vm._v(_vm._s(_vm.firmAttributes.phone)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.mobile
        ? _c("dt", [_vm._v("\n        Mobil\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.mobile
        ? _c("dd", [
            _c("a", { attrs: { href: "tel://" + _vm.firmAttributes.mobile } }, [
              _vm._v(_vm._s(_vm.firmAttributes.mobile)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.email
        ? _c("dt", [_vm._v("\n        Email\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.firmAttributes.email
        ? _c("dd", [
            _c("a", { attrs: { href: "mailto:" + _vm.firmAttributes.email } }, [
              _vm._v(_vm._s(_vm.firmAttributes.email)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }